import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Gallery, Homepage } from './pages';
import { Footer, NavigationTop } from './components/index';


function App() {

  return (
    <div className='app'>
      <NavigationTop />

     

      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/home' element={<Homepage />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='*' element={<Homepage />} />
        {/* <Navigate to='/home' />
        </Route> */}
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
